/** Shared horizontal zoom steps for Production Track and Losses Track. */
export const TRACK_ZOOM_STEPS = [1, 1.5, 2, 3, 4, 6, 8];

export function trackZoomFactor(zoomIndex) {
  const idx = Math.min(
    Math.max(0, zoomIndex || 0),
    TRACK_ZOOM_STEPS.length - 1
  );
  return TRACK_ZOOM_STEPS[idx];
}
